import { render } from "./RecipeSearchCard.vue?vue&type=template&id=74b18ee2"
import script from "./RecipeSearchCard.vue?vue&type=script&lang=js"
export * from "./RecipeSearchCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/dotter/dotter/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__